"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledSideBar = void 0;
const ui_components_1 = require("@groupby/ui-components");
const styled_components_1 = __importDefault(require("styled-components"));
exports.StyledSideBar = styled_components_1.default.div `
  position: sticky;
  top: 0;
  margin-bottom: -${({ theme }) => theme.footer.height};
  height: 100vh;
  background-color: ${ui_components_1.baseColors.white};
  overflow-y: auto;

  @media (max-width: ${({ theme }) => theme.appBreakpoints.md}px) {
    margin-bottom: -${({ theme }) => theme.footer.heightMobile};
  }
`;
